import * as React from 'react';
import classNames from 'classnames';
import { useIntl } from '@grandvisionhq/state';

const OneTrustCookieSettingsButton = ({ className  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("button", {
        className: classNames('ot-sdk-show-settings', className),
        id: "ot-sdk-btn",
        "data-t": "onetrust-button"
    }, getLabel('cookieConsent.button.settings'));
};

export { OneTrustCookieSettingsButton };
//# sourceMappingURL=onetrust-cookiesettings-button.js.map
